import React from 'react';
import { makeStyles, Skeleton } from '~/lib/bn-material-ui';
import BinLevelUnmonitored from '~/bins/bin-level/bin-unmonitored';
import { binDimensionsArePlottable, BinCircularProfileSvg } from '~/bins/bin-level/bin-circular-profile-svg';
import BinLevelUnknown from '~/bins/bin-level/bin-level-unknown';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

const useBinLevelProfileStyles = makeStyles((theme) => ({
  noDimensionProfile: {
    width: '100%',
    height: '100%',
    border: `2px solid ${theme.palette.gray[50]}`,
    borderRadius: '4px',
  },
}));

export function BinLevelProfile({ binHref, heightPx, widthPx, scale, binPolygonClassName = undefined, feeds = undefined }) {
  const { entity: binEntity, loading: binLoading } = useSirenEntity({ href: binHref });

  const binLevelProfileStyles = useBinLevelProfileStyles();

  if (binLoading || !binEntity) {
    return <Skeleton
      variant='image'
      className={binLevelProfileStyles.noDimensionProfile}
      width={widthPx}
      height={heightPx}
    />;
  }

  const { volumes, dimensions, monitoringType } = binEntity.properties;

  if (monitoringType === 'monitored' && binDimensionsArePlottable(dimensions)) {
    return <BinCircularProfileSvg
      binDimensions={dimensions}
      binVolumes={volumes}
      feeds={feeds ? feeds : []}
      heightPx={heightPx}
      widthPx={widthPx}
      scale={scale}
      verticalAlign='bottom'
      binPolygonClassName={binPolygonClassName}
    />;
  }

  if (monitoringType === 'unmonitored') {
    return <BinLevelUnmonitored
      href={binHref}
      className={binLevelProfileStyles.noDimensionProfile}
      volumes={volumes}
    />;
  }

  return <BinLevelUnknown className={binLevelProfileStyles.noDimensionProfile}/>;
}

